import React, { useEffect, useMemo, useState } from 'react';
import api from '../../utils/api';
import { FaSignInAlt, FaTruck, FaWarehouse } from 'react-icons/fa';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../components_shared/PortalDashboard';

export default function GateDashboardPage(){
  const [stats,setStats]=useState(null);
  const [series,setSeries]=useState([]);

  useEffect(()=>{(async()=>{
    try{
      const [totalRes,incRes,arrRes]=await Promise.all([
        api.get('/api/v1/inventory/dispatch-notes',{params:{page:0,size:1}}),
        api.get('/api/v1/inventory/dispatch-notes',{params:{status:'DISPATCHED',page:0,size:1}}),
        api.get('/api/v1/inventory/dispatch-notes',{params:{status:'ARRIVED_GATE',page:0,size:1}})
      ]);
      setStats({
        total: totalRes.data.totalElements||0,
        incoming: incRes.data.totalElements||0,
        arrived: arrRes.data.totalElements||0
      });
      // fetch 30-day arrivals
      const end=new Date(); const start=new Date(); start.setDate(end.getDate()-29);
      const fmt=d=>d.toISOString().slice(0,10);
      const rep=await api.get('/api/v1/inventory/reports/gate',{params:{from:fmt(start),to:fmt(end)}});
      const chartRows=[];
      for(let d=new Date(start); d<=end; d.setDate(d.getDate()+1)){
        const ds=fmt(d);
        chartRows.push({name:ds.slice(5),value:rep.data.find(x=>x.date===ds)?.count||0});
      }
      setSeries(chartRows);
    }catch{setStats({total:0,incoming:0,arrived:0});}
  })();},[]);

  const safeStats=stats||{total:0,incoming:0,arrived:0};

  const cards=[
    {icon:<FaWarehouse/>,label:'Total Shipments',value:safeStats.total,desc:'All tracked dispatches',className:'eduss-dashboard-card-blue'},
    {icon:<FaTruck/>,label:'Incoming',value:safeStats.incoming,desc:'On the way to gate',className:'eduss-dashboard-card-yellow'},
    {icon:<FaSignInAlt/>,label:'Arrived Today',value:safeStats.arrived,desc:'Ready for gate scan',className:'eduss-dashboard-card-green'}
  ];
  const charts=useMemo(()=>[
    {title:'Gate Queue',caption:'Shipment status',type:'bar',data:[
      {name:'Total',value:Number(safeStats.total||0)},
      {name:'Incoming',value:Number(safeStats.incoming||0)},
      {name:'Arrived',value:Number(safeStats.arrived||0)}
    ],color:'#0f6fad'},
    {title:'Arrival Trend',caption:'Last 30 days',type:'line',data:series.length?series:[{name:'No Data',value:0}],color:'#10ac84'}
  ],[safeStats.total,safeStats.incoming,safeStats.arrived,series]);

  if(!stats) return <div>Loading...</div>;

  return (
    <div className="eduss-dashboard">
      <PortalHero title="Gate Officer Dashboard" subtitle="Watch incoming vehicles, arrivals, and QR gate scan activity." />
      <KpiGrid cards={cards} />
      <DashboardChartGrid charts={charts} />
    </div>
  );
}
